export default {
  'addOA.title': '加入官方帳號',
  'addOA.button.text': '加入好友後點擊連結領券',
  'addOA.content.text': '加入官方帳號好友後，即可獲得並使用此票券，以及獲得更多優惠及權益通知。',
} as Record<string, string>;
